<template>
  <div class="agreement-table">
    <!--新增/删除按钮-->
    <vxe-toolbar size="mini" v-if="!isHiddenTopBtn">
      <template v-slot:buttons>
        <el-button type="primary" size="small" class="vxe-btn-primary" @click="addNewRowHandler"
          >新增</el-button
        >
        <el-button
          size="small"
          type="danger"
          class="vxe-btn-delete"
          @click="deleteBtnClickHandler()"
          >删除</el-button
        >
      </template>
    </vxe-toolbar>
    <!---可编辑表格-->
    <vxe-grid
      keep-source
      border
      size="mini"
      align="center"
      show-overflow
      show-header-overflow
      ref="xTableRef"
      class="vxe-table-element"
      resizable
      :auto-resize="true"
      :data="tableData"
      show-footer
      :footer-method="footerMethod"
      :valid-config="{ autoPos: true, message: 'inline' }"
      :edit-rules="tableRule"
      :edit-config="editConfig"
      :height="300"
      @edit-closed="closeEditTableHandler"
      @select-change="handleSelectionChange"
      @select-all="handleSelectionChange"
    >
      <vxe-table-column type="checkbox" width="50" fixed="left"> </vxe-table-column>
      <vxe-table-column type="seq" title="序号" width="80"></vxe-table-column>
      <vxe-table-column type="seq" title="行项目号" width="100"></vxe-table-column>
      <template v-for="(item, index) in computedPurchaseAgreementColumns">
        <!-- 如果有合并表头的时候 -->
        <template v-if="item.children && item.children.length">
          <vxe-table-column :key="index" :title="item.title" align="center">
            <vxe-table-column
              v-for="(child, index1) in item.children"
              :key="index1"
              :field="child.field"
              :width="child.width"
              :edit-render="child.editRender"
              :title="child.title"
              :visible="child.visible"
            >
              <template v-slot="{ row }">
                <template v-if="child.field == 'isFixedPrice'">
                  <span>{{ row[child.field] == '0' ? '否' : '是' }}</span>
                </template>
                <template v-else-if="item.field == 'productQuantity'">{{
                  replaceLastZeroStr(row[item.field])
                }}</template>
                <template v-else-if="item.field == 'businessContractUnitPrice'">{{
                  replaceLastZeroStr(row[item.field])
                }}</template>
                <span v-else>{{ row[child.field] }}</span>
              </template>
              <template v-slot:edit="{ row }">
                <!-- 合同价格 -->
                <InputNumberAd
                  :controls="false"
                  class="inputWidth"
                  :precision="6"
                  max="99999999999"
                  v-if="child.editRender?.name == 'businessContractUnitPrice'"
                  v-model="row[child.field]"
                  @input="() => handleChange(row, child.field)"
                ></InputNumberAd>
                <!-- 价税合计金额 -->
                <InputNumberAd
                  :controls="false"
                  class="inputWidth"
                  :precision="6"
                  max="99999999999"
                  v-if="child.editRender?.name == 'businessContractTotalAmount'"
                  v-model="row[child.field]"
                  @input="() => handleChange(row, child.field)"
                ></InputNumberAd>
                <!-- 税额 -->
                <InputNumberAd
                  :controls="false"
                  class="inputWidth"
                  :precision="6"
                  max="99999999999"
                  v-if="child.editRender?.name == 'businessContractTaxAmount'"
                  v-model="row[child.field]"
                  @input="() => handleChange(row, child.field)"
                ></InputNumberAd>
                <!-- 净值 -->
                <!-- <InputNumberAd
                  :controls="false"
                  class="inputWidth"
                  :precision="6"
                  max="99999999999"
                  v-if="child.editRender?.name == 'businessContractPureAmount'"
                  v-model="row[child.field]"
                  @input="() => handleChange(row, child.field)"
                ></InputNumberAd> -->
                <!-- 变动单价 -->
                <InputNumberAd
                  :controls="false"
                  class="inputWidth"
                  :precision="6"
                  max="99999999999"
                  v-if="child.editRender?.name == 'businessChangeUnitPrice'"
                  v-model="row[child.field]"
                  @input="() => handleChange(row, child.field)"
                ></InputNumberAd>
                <!-- 价税合计金额 -->
                <InputNumberAd
                  :controls="false"
                  class="inputWidth"
                  :precision="6"
                  max="99999999999"
                  v-if="child.editRender?.name == 'businessChangeTotalAmount'"
                  v-model="row[child.field]"
                  @input="() => handleChange(row, child.field)"
                ></InputNumberAd>
                <!-- 税额 -->
                <InputNumberAd
                  :controls="false"
                  class="inputWidth"
                  :precision="6"
                  max="99999999999"
                  v-if="child.editRender?.name == 'businessChangeTaxAmount'"
                  v-model="row[child.field]"
                  @input="() => handleChange(row, child.field)"
                ></InputNumberAd>
                <!-- 净值 -->
                <InputNumberAd
                  :controls="false"
                  class="inputWidth"
                  :precision="6"
                  max="99999999999"
                  v-if="child.editRender?.name == 'businessChangePureAmount'"
                  v-model="row[child.field]"
                  @input="() => handleChange(row, child.field)"
                ></InputNumberAd>
              </template>
            </vxe-table-column>
          </vxe-table-column>
        </template>
        <template v-else>
          <vxe-table-column
            :key="index"
            :type="item.type"
            :fixed="item.fixed"
            :field="item.field"
            :title="item.title"
            :width="item.width"
            :visible="item.visible"
            :sortable="item.sortable"
            :edit-render="item.editRender"
          >
            <template v-slot="{ row }">
              <template v-if="item.field == 'isFixedPrice'">
                <span>{{ row[item.field] == '0' ? '否' : '是' }}</span>
              </template>
              <template v-else-if="item.field == 'priceIdentity'">
                <template v-if="row[item.field] == '0'">未定价</template>
                <template v-else>已定价</template>
              </template>
              <template v-else-if="item.field == 'productQuantity'">{{
                replaceLastZeroStr(row[item.field])
              }}</template>
              <template v-else-if="item.field == 'businessContractUnitPrice'">{{
                replaceLastZeroStr(row[item.field])
              }}</template>
              <span v-else>{{ row[item.field] }}</span>
            </template>
            <template v-slot:edit="{ row }">
              <!-- 商品 -->
              <search-table
                v-if="item.editRender?.name == 'productDesc'"
                v-model="row[item.field]"
                searchType="product"
                :isMultiple="true"
                :extraData="{
                  detailProductStatus: 'ZT03',
                  contractCategory: $route.query.contractCategory == 'sales' ? 'sales' : 'purchase',
                  adminFlag: 2,
                  selectCompanyCode: baseFormData?.companyCode,
                }"
                :currentValue="row[item.field]"
                @input="(val) => chooseTable(val, row, item.field)"
              ></search-table>
              <!-- 采购数量 -->

              <InputNumberAd
                :controls="false"
                class="inputWidth"
                :precision="6"
                max="99999999999"
                v-if="item.editRender?.name == 'productQuantity'"
                v-model="row[item.field]"
                @input="() => handleChange(row, item.field)"
              ></InputNumberAd>
              <!-- 是否定价 -->
              <el-select
                v-if="item.editRender?.name == 'isFixedPrice'"
                filterable
                clearable
                v-model="row[item.field]"
                @change="() => handleChange(row, item.field)"
              >
                <el-option value="1" label="是"></el-option>
                <el-option value="0" label="否"></el-option>
              </el-select>
              <!-- 合同价格 -->
              <InputNumberAd
                :controls="false"
                class="inputWidth"
                :precision="6"
                max="99999999999"
                v-if="item.editRender?.name == 'businessContractUnitPrice'"
                v-model="row[item.field]"
                @input="() => handleChange(row, item.field)"
              ></InputNumberAd>
              <!-- 仓库 -->
              <search-table
                v-if="item.editRender?.name == 'storageName'"
                v-model="row[item.field]"
                searchType="warehouse"
                :isMultiple="true"
                :extraData="{
                  currentStatus: 'ZT03',
                  contractCategory: $route.query.contractCategory == 'sales' ? 'sales' : 'purchase',
                  adminFlag: 2,
                  selectCompanyCode: baseFormData.companyCode,
                }"
                :currentValue="row[item.field]"
                @input="(val) => chooseTable(val, row, item.field)"
              ></search-table>
              <!-- 价格确定时间 -->
              <InputNumberAd
                :controls="false"
                class="inputWidth"
                :precision="6"
                max="99999999999"
                v-if="item.editRender?.name == 'priceConfirmDate'"
                v-model="row[item.field]"
                @input="() => handleChange(row, item.field)"
              ></InputNumberAd>
              <!-- 价格标识 -->
              <!-- <el-input
                v-if="item.editRender?.name == 'priceIdentity'"
                v-model="row[item.field]"
                disabled
                @input="() => handleChange(row, item.field)"
              /> -->
              <span v-if="item.editRender?.name == 'priceIdentity'">
                <template v-if="row[item.field] == '0'">未定价</template>
                <template v-else>已定价</template>
              </span>
              <!-- 单位 -->
              <el-input
                v-if="item.editRender?.name == 'unit'"
                v-model="row[item.field]"
                disabled
                @input="() => handleChange(row, item.field)"
              />
              <!-- 增值税 -->
              <InputNumberAd
                :controls="false"
                class="inputWidth"
                :precision="6"
                max="99999999999"
                v-if="item.editRender?.name == 'taxRate'"
                v-model="row[item.field]"
                @input="() => handleChange(row, item.field)"
              ></InputNumberAd>
              <!-- 交货数量 -->
              <InputNumberAd
                :controls="false"
                class="inputWidth"
                :precision="6"
                max="99999999999"
                disabled
                v-if="item.editRender?.name == 'productQuantity1'"
                v-model="row[item.field]"
                @input="() => handleChange(row, item.field)"
              ></InputNumberAd>
              <!-- 价税合计金额 -->
              <el-input
                v-if="item.editRender?.name == 'businessContractTotalAmount'"
                disabled
                v-model="row[item.field]"
                @input="() => handleChange(row, item.field)"
              />
            </template>
          </vxe-table-column>
        </template>
      </template>
    </vxe-grid>
  </div>
</template>

<script>
  import { purchaseAgreementColumns, tableRule } from './../columns.js';
  import productMixins from './../mixins.js';
  import editTableMixin from './../editTableMixin.js';
  import {
    COMPANY_CODE1,
    COMPANY_CODE2,
    INTERNAL_SETTLEMENT,
    WITHOUT_SETTLEMENT,
    DROP_OFF_PERSON,
  } from '@/constants';
  export default {
    name: 'AgreementTable',
    mixins: [productMixins, editTableMixin],
    props: {
      fileType: {
        type: String,
        default: '',
      },
    },
    data() {
      return {
        computedPurchaseAgreementColumns: [],
        tableRule,
        edit: this.isEdit,
      };
    },
    methods: {
      // 表底合并
      footerMethod({ columns, data }) {
        const footerData = [
          columns.map((column, _columnIndex) => {
            if (_columnIndex === 0) {
              return '小计';
            }
            // if (column.property === 'domesticAmount') {
            //   return 0;
            // }
            if (column.property === 'productQuantity') {
              return this.replaceLastZeroStr(
                data.reduce((cur, next) => cur + +next.productQuantity, 0).toFixed(6)
              );
            }
            return null;
          }),
        ];
        return footerData;
      },

      // 过滤表格字段
      filterTableColumn(val) {
        const { isGenerateSales, isRelatedParty, partnerType, companyCode, ifPersonalPartner } =
          val;
        console.log(val, '表格中');
        const supplierType = this._judgeSupplierType(
          isRelatedParty,
          partnerType,
          ifPersonalPartner
        );
        const baseTableColumn = purchaseAgreementColumns(this);
        // 是否公司为城矿公司且是内部结算公司的时候才有根据条件来显示
        if (COMPANY_CODE1.includes(companyCode) && supplierType == INTERNAL_SETTLEMENT) {
          console.log('城矿公司->内部协议表格');
          if (isGenerateSales == 1) {
            this._changeTableColumnVisible(true);
          } else {
            this._changeTableColumnVisible(false);
          }
        } else if (COMPANY_CODE1.includes(companyCode) && supplierType == WITHOUT_SETTLEMENT) {
          console.log('城矿公司->外部结算协议的表格');
          // 外部结算协议的时候
          this.computedPurchaseAgreementColumns = baseTableColumn.map((item) => {
            if (['businessContractUnitPrice', 'isFixedPrice'].includes(item.field)) {
              return {
                ...item,
                visible: true,
              };
            } else {
              return item;
            }
          });
        } else if (COMPANY_CODE2.includes(companyCode) && supplierType == DROP_OFF_PERSON) {
          console.log('demo公司->协议-投送人表格');
          this.computedPurchaseAgreementColumns = baseTableColumn.map((item) => {
            if (['businessContractUnitPrice'].includes(item.field)) {
              return {
                ...item,
                visible: true,
              };
            } else {
              return item;
            }
          });
        } else {
          console.log('全部表格');
          this.computedPurchaseAgreementColumns = baseTableColumn.map((item) => {
            if (['businessContractUnitPrice', 'isFixedPrice'].includes(item.field)) {
              return {
                ...item,
                visible: true,
              };
            } else {
              return item;
            }
          });
        }
        this.$nextTick(() => {
          this.$refs.xTableRef.refreshColumn();
        });
      },
      // 切换表格列显示和隐藏
      _changeTableColumnVisible(isVisible) {
        const baseTableColumn = purchaseAgreementColumns(this);
        this.computedPurchaseAgreementColumns = baseTableColumn.map((item) => {
          if (
            [
              'isFixedPrice',
              'businessContractUnitPrice',
              'productQuantity',
              'productQuantity1',
            ].includes(item.field)
          ) {
            return {
              ...item,
              visible: isVisible,
            };
          } else {
            return item;
          }
        });
      },
    },
  };
</script>

<style></style>
